var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon othersSVGs",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2085_4868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.63907 16.7324V18.2324H8.1429V16.7324H2.15824C1.74509 16.7324 1.41016 16.3966 1.41016 15.9824V3.98242C1.41016 3.56821 1.74509 3.23242 2.15824 3.23242H6.64674C7.54047 3.23242 8.34272 3.62523 8.89099 4.24806C9.43926 3.62523 10.2415 3.23242 11.1352 3.23242H15.6237C16.0369 3.23242 16.3718 3.56821 16.3718 3.98242V15.9824C16.3718 16.3966 16.0369 16.7324 15.6237 16.7324H9.63907ZM14.8757 15.2324V4.73242H11.1352C10.3089 4.73242 9.63907 5.40399 9.63907 6.23242V15.2324H14.8757ZM8.1429 15.2324V6.23242C8.1429 5.40399 7.47307 4.73242 6.64674 4.73242H2.90632V15.2324H8.1429Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2085_4868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8172,
    height: 18,
    fill: "white",
    transform: "translate(-0.00390625 0.982422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/Book-icon.35e771d7d8af860230d51dd641f84103.svg";
export { ForwardRef as ReactComponent };